import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { TABLE_EXCLUDED, TABLE_INCLUDED } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';

import { ByPassSecurityPipe } from '../../../util/pipes/by-pass-sercurity.pipe';
import { Helper } from '../../helper';

@Component({
    selector: 'oiv-viewer-paragraph',
    imports: [ByPassSecurityPipe, MobiUiIconComponent, NgClass],
    templateUrl: './paragraph.component.html',
    styleUrl: './paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParagraphComponent {
    #helper = inject(Helper);

    eId = input('');
    cssClass = input('mobi-ui-font-size-150');
    useOriginalStyle = input(false);
    isAnchorList = input(false);
    content = input<string>('');
    isTableIncluded = computed(() => this.content().includes(TABLE_INCLUDED));
    isTableExcluded = computed(() => this.content().includes(TABLE_EXCLUDED));
    transformedContent = computed(() => {
        let content = this.#helper.handleNewLine(this.content(), this.isAnchorList());
        content = this.#helper.parseLink(content);
        content = this.#helper.parseWithBoldItalicXmlTags(content);
        return content;
    });
}
